/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { ClearableSearchField } from "components/SearchField/SearchField";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import { GridSearchIcon } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { getScreenRight } from "utils/generic";

import { Button, CardContent, InputAdornment } from "@mui/material";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { appConstants } from "utils/appConstants";
import { genericMessage } from "utils/genericMessages";
import { showResMsg } from "utils/generic";
import { deleteRoleRecords, fetchRoles } from "utils/superAdminApi";

let fetchedRoles = [];
let searchParameter = "";
let LOGIN_DETAILS;

function Roles(searchTerm) {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [rows, setRows] = useState([]);
  const [disableColor, setDisableColor] = useState(false);

  const [values, setValues] = useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    roleName: "",
    roleDescription: "",
    initialValue: "",
    finalValue: "",
    applicableForBusinessUser: "",
    searchParameterList: [
      "planName",
      "defaultPlanRole",
      "applicableForBusinessUser",
      "roleDescription",
      "roleName",
    ],
    roles: [], // add roles array to store data fetched from API
  });

  if (
    sessionStorage.getItem("LOGIN_DETAILS") !== undefined &&
    sessionStorage.getItem("LOGIN_DETAILS") != null
  ) {
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
    values.userID = LOGIN_DETAILS._id;
  }

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchRolesData();
    })();
  }, [values.sortingType, perPage, dispatch]);

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    if (LOGIN_DETAILS._id === _id) {
      showResMsg(genericMessage.logusercantdeleted, 2000, false);
      return;
    }
    values._id = [];
    values._id.push(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  function handleDelete(roleId) {
    if (
      rows.some(
        (role) => role._id === values._id[0] && role.defaultPlanRole === "Yes"
      )
    ) {
      showResMsg(genericMessage.planDefaultRolecantdeleted, 2000, false);
    } else {
      deleteRole(roleId);
    }
    setDeleteDialogeFlag(!deleteDialogeFlag);
  }

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchRolesData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const deleteRole = async (roleId) => {
    await deleteRoleRecords(
      values,
      (data) => {
        fetchRolesData();
        setTitle("");
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  const fetchRolesData = async () => {
    values.searchParameter = searchParameter;
    await fetchRoles(
      values,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  async function getRight() {
    let right = await getScreenRight("Roles");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchRolesData();
    }
  }, [values.filterValues]);

  let columns = [
    {
      name: "Role Name",
      selector: (row) => row.roleName,
      sortable: true,
      sortField: "roleName",
      left: true,
    },
    {
      // name: "Role Description",
      name: <p style={{ paddingRight: "px" }}>Role Description</p>,
      selector: (row) => row.roleDescription,
      sortable: true,
      sortField: "roleDescription",
    },
    {
      name: "Plan Name",
      selector: (row) => row.planName,
      sortable: true,
      sortField: "planName",
      center: true,
    },
    {
      name: "Associated Plan Default Role",
      selector: (row) => row.defaultPlanRole,
      sortable: true,
      sortField: "defaultPlanRole",
      center: true,
    },
    {
      name: "Applicable For Business User",
      selector: (row) => row.applicableForBusinessUser,
      sortable: true,
      sortField: "applicableForBusinessUser",
      center: true,
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              <Link to={`/roles/edit/${row._id}`}>
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item>
              <Link
                to={{
                  pathname: `/roles/${row._id}`,
                }}
              >
                <TimelineItem color="success" icon="tune" title="Permission" />
              </Link>
            </Grid>
            <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Roles" />
          <Grid container display={"flex"} justifyContent="end" mt={2} gap={2}>
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchRolesData();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.5rem  0.5rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={fetchRolesData}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: "16px" }}>
              <Link to={"/roles/new"}>
                <MDButton
                  variant="contained"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color={disableColor ? "secondary" : "success"}
                  style={{ height: "44.11px", width: "99px" }}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </Card>
      </div>

      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
    </DashboardLayout>
  );
}

export default Roles;
